import Vue from "vue";
import customDialog from "./components/LoginDialog.vue";
import router from "@/router/index";

//  生成类
const dialogConstrutor = Vue.extend(customDialog);
let currentDialogInstance = null; // 用于存储当前活动的对话框实例
//  将组件挂在到Vue原型链
const loginDialog = (options) => {
  return new Promise((resolve, reject) => {
    //  创建实例
    let current = null;
    // to: 登录成功后跳转的路径
    let toPath = options.to;
    // type: 唤起登录弹窗的方式，
    // 值：page 切换页面唤起 ，button 点击按钮主动唤起， api 接口调用唤起
    let type = options.type;
    // 是否展示入驻权益
    const isShowEquity = options.isShowEquity || false;
    if (!currentDialogInstance) {
      current = new dialogConstrutor({
        //  将实例挂在到div元素
        el: document.createElement("div"),
        store: options.store,
        router: options.router,
      });
      current.show = true;
      current.isShowEquity = isShowEquity;
      current.$el.setAttribute("data-dialog", "login"); // 设置 data 属性
      document.body.appendChild(current.$el);
      currentDialogInstance = current;
    } else {
      current = currentDialogInstance;
      current.isShowEquity = isShowEquity;
      current.show = true;
    }
    // 登录成功
    current.loginSuccess = () => {
      if (options.success) {
        current.show = false;
        options.success();
        resolve();
        return;
      }
      if (toPath) {
        current.$router.push(toPath);
      } else {
        current.$router.go(0);
      }
      current.show = false;
      if (options.exchangeCode) {
        localStorage.setItem("exchangeCode", options.exchangeCode);
      }
      resolve();
    };
    // 关闭
    current.close = () => {
      if (type === "page") {
        // 如果是切换页面唤起登录，关闭时回首页
        // current.$router.push("/");
      }
      reject();
      current.show = false;
    };
    // 当 show 变为 false 时，移除对话框
    current.$once("hook:beforeDestroy", () => {
      document.body.removeChild(current.$el);
    });
    // 保存当前对话框实例的引用
    Vue.prototype.$currentLoginDialog = current;
  });
};

// //  将组件挂载到Vue原型链
// const createLoginDialog = () => {
//   Vue.prototype.$loginDialog = loginDialog;
// };
// 定义插件
const DialogPlugin = {
  install(Vue, options) {
    // 注册全局方法
    Vue.prototype.$loginDialog = (params) => {
      if (window.isElectron) {
        router.push({ name: "LoginPage" });
        return false;
      }
      if (!options.store || !options.router) {
        throw new Error("Store and Route must be provided.");
      }
      return loginDialog({ ...options, ...params });
    };
  },
};
export default DialogPlugin;
